import React, { useState, useEffect } from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { FlagLabels } from "./FlaggedJournals";
import { ReactComponent as TriangleFlag } from "../../../../assets/icons/TriangleFlag.svg";
import moment from "moment";
import {
  assessmentNameLookup,
  flagLabels,
  assesmentsToSelectYouth,
  assesmentsToSelectAdult,
} from "../../../../constants/constants";
import SingleAssessmentModal from "../Assessments/SingleAssessmentModal";
import { useSelector } from "react-redux";
import {
  getTagBasedOnScore,
  getMaxScoreBasedOnAnswerGroups,
} from "../../../../util/helpers";
import PatientLoader from "../../../common/PatientLoader";
const AssessmentItem = ({
  assessmentData,
  assessmentName,
  pdfMode = false,
}) => {
  const { assessmentTypes } = useSelector((state) => state.assessment);
  let thisAssessment = assessmentTypes.find(
    (element) => element.name === assessmentName
  );
  let maxScore = assessmentData?.total;
  let assessmentTag = assessmentData?.flag;
  if (!maxScore || !assessmentTag) {
    maxScore = getMaxScoreBasedOnAnswerGroups(
      thisAssessment?.answer_group,
      thisAssessment?.questionnaire
    );

    assessmentTag = getTagBasedOnScore(
      assessmentData?.score,
      thisAssessment?.tag_group
    );
  }

  const labelStyles = flagLabels[assessmentTag || "severe depression"];
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <>
      <SingleAssessmentModal
        modalIsOpen={isModalOpen}
        setModalOpen={setModalOpen}
        assessment={assessmentData}
        assessmentName={assessmentName}
        flag={assessmentTag}
      />
      <tr
        className="py-3"
        style={{
          height: "4rem",
          verticalAlign: "middle",
        }}
      >
        <td>
          <small style={{ fontWeight: "500", color: labelStyles?.color }}>
            {moment(assessmentData?.created).format("MMM DD, YYYY") ||
              "Not Available"}
          </small>
        </td>
        <td>
          <small style={{ fontWeight: "500", color: labelStyles?.color }}>
            {assessmentNameLookup[assessmentName.toLowerCase()] ||
              assessmentName}
          </small>
        </td>
        <td>
          <small style={{ fontWeight: "500", color: labelStyles?.color }}>
            {assessmentData?.score || 0}/
            {assessmentData?.total || maxScore || 0}
          </small>
        </td>
        <td style={{ width: "15%" }}>
          <FlagLabels label={assessmentTag || "severe depression"} />
        </td>
        {!pdfMode && (
          <td>
            <button
              className="primary-btn-small"
              style={{ padding: "0px !important" }}
              onClick={() => {
                setModalOpen(true);
              }}
            >
              View
            </button>
          </td>
        )}
      </tr>
    </>
  );
};
export const AssessmentsTable = ({
  assessmentData,
  onlyTaken = false,
  pdfMode = false,
}) => {
  // console.log('assessmentData', assessmentData);
  return (
    <table className="table my-3 px-2">
      <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
        <tr
          style={{
            height: "4rem",
            verticalAlign: "middle",
          }}
        >
          <th scope="col">
            <span className="muted-text">Date Taken</span>
          </th>
          <th scope="col">
            <span className="muted-text">Assessment Name</span>
          </th>
          <th scope="col">
            <span className="muted-text">Score</span>
          </th>
          <th scope="col">
            <span className="muted-text">Tag</span>
          </th>
          {!pdfMode && (
            <th scope="col">
              <span className="muted-text">Action</span>
            </th>
          )}
        </tr>
      </thead>
      {onlyTaken ? (
        <tbody>
          {assessmentData?.length > 0 &&
            assessmentData?.sort((a, b) => {
              const dateA = new Date(a.data?.created);
              const dateB = new Date(b.data?.created);
              return dateB - dateA; 
            }).map((assessment, index) => {
              return (
                <AssessmentItem
                  assessmentData={
                    assessment["data"] || assessmentData[assessment][0]
                  }
                  assessmentName={assessment["name"]}
                  pdfMode={pdfMode}
                  key={index}
                />
              );
            })}
        </tbody>
      ) : (
        <tbody>
          {Object.keys(assessmentData).length > 0 &&
            Object.keys(assessmentData)
              .filter((item) => {
                if (!item.includes("ournal")) {
                  return item;
                }
              })
              .map((assessment, index) => {
                return (
                  <AssessmentItem
                    assessmentData={assessmentData[assessment][0]}
                    assessmentName={assessment}
                    key={index}
                  />
                );
              })}
        </tbody>
      )}
    </table>
  );
};

const AllAssessments = (props) => {
  const { assessmentLoading, assessmentsData } = useSelector(
    (state) => state.assessment
  );
  const [formattedData, setFormattedData] = useState([]);
  const selectedAssessment = props.assessmentFilterValue;
  const selectedCaregiverDropVal = props.careGiverFilterValue;  
  const caregiverAllAssesments = props.caregiverAllAssesments;

  useEffect(() => {
    if (assessmentLoading) return;
    const tempObj = Object.entries(assessmentsData);
    const tempCaregiverAssessment = Object.entries(caregiverAllAssesments);
    let assessmentData = [];
    if (tempObj?.length > 0) {
      for (const [name, data] of tempObj) {
        //filter to include only dropdown vals
        if (!name.includes("ournal") && data?.length > 0) {
          data
            ?.filter((item) => {
              // console.log("name",name)
              if (
                selectedAssessment?.label?.includes("All") ||
                selectedAssessment?.label === undefined
              ) {
                return item;
              }
              //return selectedAssessment?.label.includes(name);
              return name.includes(selectedAssessment?.label);
            })
            ?.filter((item) => {
              if (
                selectedCaregiverDropVal?.label?.includes("All") ||
                selectedCaregiverDropVal?.label === undefined
              ) {
                return item;
              } else if (
                selectedCaregiverDropVal?.label?.includes("Caregiver")
              ) {
                if (name.includes("Informant")) return item;
              } else if (
                selectedCaregiverDropVal?.label?.includes("Patient")
              ) {
                if (!name.includes("Informant")) return item;
            }
            })
            ?.forEach((item) => {
              assessmentData.push({
                name: name,
                data: item,
              });
            });
        }
      }
    }
    if (tempCaregiverAssessment?.length > 0) {
      for (const [name, data] of tempCaregiverAssessment) {
        if (!name.includes("ournal") && data?.length > 0) {
          data
            ?.filter((item) => {
              if (
                selectedAssessment?.label?.includes("All") ||
                selectedAssessment?.label === undefined
              ) {
                return item;
              }
              return selectedAssessment?.label.includes(name);
            })
            ?.filter((item) => {
              if (
                selectedCaregiverDropVal?.label?.includes("All") ||
                selectedCaregiverDropVal?.label === undefined
              ) {
                return item;
              } 
              else if (
                selectedCaregiverDropVal?.label?.includes("Caregiver")
              ) {
                    if (name.includes("Informant")) return item;
                } 
                else if (
                  selectedCaregiverDropVal?.label?.includes("Patient")
                ) {
                  if (!name.includes("Informant")) return item;
              }
            })
            ?.forEach((item) => {
              assessmentData.push({
                name: name,
                data: item,
              });
            });
        }
      }
    }
    assessmentData = assessmentData.sort((a, b) => {
      const dateA = new Date(a?.data?.created);
      const dateB = new Date(b?.data?.created);
      return dateA - dateB; // Compare in ascending order
    });
    setFormattedData(assessmentData);
    console.log("assessmentData : ",assessmentData)
  }, [
    assessmentLoading,
    props?.assessmentFilterValue,
    props?.careGiverFilterValue,
    assessmentsData,
  ]);

  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      {assessmentLoading ? (
        <PatientLoader />
      ) : (
        <div className="container-fluid p-4">
          <div className="d-flex justify-content-between mb-4 mt-2">
            <label style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}>
              <TriangleFlag /> All Assessments
            </label>
            <small
              onClick={() => {
                props.setAssessmentsTab();
              }}
              style={{
                color: "#395e9d",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            ></small>
          </div>
          <div
            className="container-fluid"
            style={{ height: "40vh", overflowY: "scroll" }}
          >
            <AssessmentsTable assessmentData={formattedData} onlyTaken={true} />
          </div>
        </div>
      )}
    </CardLayout>
  );
};
export default AllAssessments;
